<!-- 消息模块 -->
<template>
  <div class="allNews">
    <template v-if="!showflowDetailBoolean">
      <div class="tabs">
        <ul class="role-auth-title">
          <li :class="{ active: isRead == 0 }" @click="chooseType(0)">
            未读消息
          </li>
          <li :class="{ active: isRead == 1 }" @click="chooseType(1)">
            已读消息
          </li>
        </ul>
        <div class="right">
          <el-form inline label-width="80px">
            <el-form-item label="项目来源">
              <el-select v-model="prjId" size="small" filterable clearable :title="prjValueTitle" @change="getList(1)">
                <el-option value label="全部"></el-option>
                <el-option v-for="(item, index) in projectlist" :key="index" :label="item.prjName" :value="item.prjId" :title="item.prjName" style="width: 200px">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-right: 0 !important;">
              <el-input v-model="content" placeholder="请输入标题或内容查询" size="small" clearable @input="getList(1)">
                <i slot="suffix" class="el-input__icon el-icon-search" @click="getList(1)"></i>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="body">
        <div class="top">
          <el-button icon="el-icon-refresh" size="small" class="handleRead" plain @click="refreshList">
            刷新
          </el-button>
          <el-button size="small" class="handleRead" plain @click="selectAll">
            全选
          </el-button>
          <el-button v-if="isRead == 0" :disabled="selectionList.length == 0" size="small" plain class="handleRead"
            @click="isReadBtn">
            标记为已读
          </el-button>
          <el-button v-if="deleNews" :disabled="selectionList.length == 0" size="small" class="handleRead" type="danger"
            plain @click="deleteBtn">
            删除
          </el-button>
        </div>
        <div class="table">
          <el-table key="isRead" ref="messageData" v-loading="loading" :data="messageData" :show-header="true"
            element-loading-text="拼命加载中" style="width: 100%" height="100%" border @selection-change="handleSelectionChange">
            <template slot="empty">
              <img :src="zanwu" alt="" />
              <p style="font-size: 16px; color: #000; margin-top: 36px">
                暂无消息
              </p>
            </template>
            <el-table-column type="selection" width="35" align="center"></el-table-column>
            <el-table-column show-overflow-tooltip label="发送人" width="100" align="center" sortable prop="sender"></el-table-column>
            <el-table-column label="状态" align="center" width="110" sortable prop="isRead">
              <template slot-scope="{ row }">
                <div class="isReadBox">
                  <p class="isRead" :class="row.isRead === 1 ? 'isReadBg' : 'isNoReadBg'"></p>
                  <span :style="row.isRead === 1 ? 'color:#b5bed2' : 'color:var(--theme-color)'">{{ ['未读','已读'][row.isRead] }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-slot="{ row }" label="标题" align="center" sortable prop="title">
              <div style="text-align: left;">
                <el-link type="primary" @click="openDetailChange(row)">
                  <span class="tabLinkSpan" :title="row.messageInfoVo.title">{{ row.messageInfoVo.title }}</span>
                </el-link>
              </div>
            </el-table-column>
            <el-table-column v-slot="{ row }" label="内容" align="center" sortable prop="content">
              <div style="text-align: left;">
                <span :title="row.content">{{ row.content }}</span>
              </div>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="项目名称" width="120" align="center" sortable prop="prjName">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="送达时间" width="200" align="center" sortable prop="createDate">
            </el-table-column>
          </el-table>
        </div>
        <div v-if="page.totalCount > 0" class="page">
          <page :page="page" class="el-pagination" @handleSizeChange="handleSizeChange"
            @handleCurrentChange="fetchData">
          </page>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import request from "@/CommonDP/service/message-service";
import flowService from "@/CommonDP/service/flow-service";
import requestprj from "@/CommonDP/service/integratedModel-service";
import page from "@/CommonDP/components/paging";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
import requestIssueMg from "@/CommonDP/service/issueMg-service";
import { filePreviewV1 } from "@/CommonDP/utils/docPublic";
import keyCatalog from "@/CommonDP/service/folder-service";
import { openFlow } from "@/CommonDP/components/processComponents/flowNew/index.js";

export default {
  name: "AllMessage",
  inject: ["reload"],
  components: { page },
  props: {
    category: { default: 0, type: Number } // 0 项目  1 批注 2 流程 3其他 4计划
  },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      prjId: "",
      messageData: [],
      isRead: 0,
      content: "",
      selectionList: [],
      selectDataList: [],
      selectAllFlag: false,
      projectlist: [],
      loading: true,
      deleNews: checkPermission(this.$allPerms.MAINMGNEWS_DELE),
      customizeComponent: "",
      showflowDetailBoolean: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    prjValueTitle() {
      let prjName = '';
      if (this.projectlist.length) {
        prjName = this.projectlist.filter(({ prjId }) => prjId === this.prjId)[0]?.prjName;
      }
      return prjName;
    }
  },
  watch: {
    category(val) {
      this.getList(1);
    }
  },
  mounted() {
    this.getList(1);
    this.getprojectlist();
  },
  methods: {
    async reback(val) {
      if (val === "reback") {
        this.showflowDetailBoolean = false;
        this.getList(1);
      }
    },
    refreshList() {
      this.chooseType(this.isRead);
    },
    chooseType(key) {
      this.messageData = [];
      this.loading = true;
      this.isRead = key;
      this.getList(1);
    },
    addNewsNumKey() {
      this.$store.dispatch("setNewsNumKey", new Date().getTime());
    },
    async getprojectlist() {
      if (this.enterpriseId) {
        const params = {
          enterpriseId: this.enterpriseId,
          prjName: "",
          prjCode: "",
          prjType: "",
          prjLevel: ""
        };
        const res = await requestprj.queryPrj(params);
        this.projectlist = res.data;
      }
    },
    // 跳转项目
    async turnRouterPrj(item) {
      const id = item.messageInfoVo.messageId;
      if (this.isRead === 0) {
        item.isRead = 1;
        await this.openDetail(id);
      }
      const obj = {
        prjId: item.messageInfoVo.prjId,
        prjName: item.messageInfoVo.prjName,
        prjCode: item.messageInfoVo.prjCode
      };
      this.$store.dispatch("updatePrj", obj);
      if (item.messageInfoVo.prjIsDelete === "1") {
        this.$message.warning("该项目已经被删除");
      } else if (item.messageInfoVo.prjIsDelete === "0") {
        const prjId = item.messageInfoVo.prjId;
        const res = await keyCatalog.checkCatalogIsInit({ prjId: prjId });
        this.$store.dispatch("setCatalogToken", res.data ? "1" : "0");
        this.$router.push({ name: "XtDesign" });

        this.reload();
      }
    },
    // 跳转问题
    async turnRouterModel(item) {
      const id = item.messageInfoVo.messageId;
      if (this.isRead === 0) {
        item.isRead = 1;
        await this.openDetail(id);
      }
      var objNew = JSON.parse(item.messageInfoVo.extraParams);
      if (item.messageInfoVo.prjIsDelete === "1") {
        this.$message.warning("该项目已经被删除");
      } else if (item.messageInfoVo.prjIsDelete === "0") {
        // 查看问题消息是否删除
        const result = await request.drawingAnnotation(objNew.questionId);
        if (result.result === "0") {
          const obj = {
            prjId: item.messageInfoVo.prjId,
            prjName: item.messageInfoVo.prjName,
            prjCode: item.messageInfoVo.prjCode
          };
          this.$store.dispatch("updatePrj", obj);
          await this.openPreviewing(objNew.questionId);
        }
      }
    },
    /**
     * 打开文件并且跳转到问题
     * @param id
     */
    async openPreviewing(id) {
      const res = await requestIssueMg.getDrawingQuestionDetails(id);
      if (!res || !res.data) return;
      const rowData = res.data;
      await this.$store.dispatch("setModelquestionData", rowData);
      const { fileList, fileTypeInt, questionId, anchorPoint } = rowData;
      let folderId, fileVersion, fileType;
      if (fileList.length > 1) {
        folderId = fileList.map((ele) => ele.fileId).join(",");
        fileVersion = fileList.map((ele) => ele.fileVersion).join(",");
        fileType = Number(fileTypeInt);
      } else {
        folderId = fileList[0].fileId;
        fileVersion = fileList[0].fileVersion;
        fileType = Number(fileTypeInt);
      }
      const data = {
        status: "2",
        fileId: folderId,
        versionId: fileVersion,
        parentId,
        questionId,
        fileType,
        anchorPoint
      };
      filePreviewV1(data);
    },

    // 跳转流程
    async turnRouterprocess(item) {
      const id = item.messageInfoVo.messageId;
      if (this.isRead === 0) {
        item.isRead = 1;
        await this.openDetail(id);
      }
      const { prjIsDelete } = item.messageInfoVo;
      if (prjIsDelete === "1") {
        this.$message.warning("该项目已经被删除");
        return;
      }
      const obj = JSON.parse(item.messageInfoVo.extraParams);
      const { flowInstanceId } = obj;
      const res = await flowService.getBusinessForm(flowInstanceId);
      const { status = 0, flowKey } = res?.data?.flowInfo;
      let approveType = "";
      if (status === 2) {
        approveType = "edit";
      } else {
        approveType = "view";
      }
      const data = { approveType, flowInstanceId, flowKey };
      await openFlow(data);
    },
    updateTable() {

    },

    // 跳转到人员管理
    async turnRouterSystem(item) {
      const id = item.messageInfoVo.messageId;
      if (this.isRead === 0) {
        item.isRead = 1;
        await this.openDetail(id);
      }
      if (item.messageInfoVo.type === 102) {
        this.$router.push("/morepersonInfo");
      } else if (item.messageInfoVo.type === 103) {
        this.$router.push("/personInfo");
      }
    },

    // 跳转到计划
    async turnRouterTask(item) {
      const id = item.messageInfoVo.messageId;
      if (this.isRead === 0) {
        item.isRead = 1;
        await this.openDetail(id);
      }
      var objNew = JSON.parse(item.messageInfoVo.extraParams);
      if (item.messageInfoVo.prjIsDelete === "1") {
        this.$message.warning("该项目已经被删除");
      } else if (item.messageInfoVo.prjIsDelete === "0") {
        // 判断当前计划是否删除
        const result = await request.prjqueryTaskNew(objNew.taskId);
        if (result.result === "0") {
          const obj = {
            prjId: item.messageInfoVo.prjId,
            prjName: item.messageInfoVo.prjName,
            prjCode: item.messageInfoVo.prjCode
          };
          this.$store.dispatch("updatePrj", obj);
          this.$router.push({ name: "taskList" });
          this.reload();
        }
      }
    },

    // 跳转到我的收藏
    async turnRouterFile(item) {
      const id = item.messageInfoVo.messageId;
      if (this.isRead === 0) {
        item.isRead = 1;
        await this.openDetail(id);
      }
      this.$router.push({ name: "mycollection" });
    },
    // 点击变已读
    async openDetailChange(item) {
      if (item.messageInfoVo.category === 0) {
        this.turnRouterPrj(item);
      } else if (item.messageInfoVo.category === 1) {
        this.turnRouterModel(item);
      } else if (item.messageInfoVo.category === 2) {
        this.turnRouterprocess(item);
      } else if (item.messageInfoVo.category === 3 && (item.messageInfoVo.type === 102 || item.messageInfoVo.type === 103)) {
        this.turnRouterSystem(item);
      } else if (item.messageInfoVo.category === 4) {
        this.turnRouterTask(item);
      } else if (item.messageInfoVo.category === 3 && (item.messageInfoVo.type === 104 || item.messageInfoVo.type === 105)) {
        this.turnRouterFile(item);
      }
    },
    async openDetail(id) {
      const res = await request.messageRead([id]);
      if (res.result === "0") {
        this.addNewsNumKey();
        this.$message.success("已读该条消息");
      }
      // await this.getList(1);
      this.$store.dispatch("unreadNum");
    },
    fetchData(val) {
      this.$nextTick(() => {
        this.$refs.messageData.bodyWrapper.scrollTop = 0;
      });
      this.getList(val);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList(1);
    },
    async getList(index) {
      const {
        isRead,
        prjId,
        content,
        enterpriseId,
        category,
        page: { pageSize }
      } = this;
      const params = {
        isRead,
        prjId,
        content,
        pageNum: index,
        pageSize,
        enterpriseId,
        category: category
      };
      if (category === 99) delete params.category;
      const { data, totalCount, pageIndex } = await request.messageList(params);
      data.forEach(ele => {
        ele.sender = this.getSenderName(ele.messageInfoVo);
        ele.title = ele.messageInfoVo.title;
        ele.content = ele.messageInfoVo.content;
        ele.prjName = ele.messageInfoVo.prjName;
        ele.createDate = ele.messageInfoVo.createDate;
      });
      this.messageData = data;
      this.page.totalCount = totalCount;
      this.page.pageNum = pageIndex;
      this.selectAllFlag = false;
      this.loading = false;
    },
    handleSelectionChange(val) {
      this.selectionList = val;
    },
    async isReadBtn() {
      if (!this.selectAllFlag) {
        const list = this.selectionList.map((item) => {
          return item.messageInfoVo.messageId;
        });
        await request.messageRead(list);
      } else {
        const list = this.selectionList.map((item) => {
          return item.messageInfoVo.messageId;
        });
        await request.messageRead(list);
      }
      this.addNewsNumKey();
      await this.getList(1);
      this.$store.dispatch("unreadNum");
    },
    selectAll() {
      if (!this.selectAllFlag) {
        this.messageData.map((item) => {
          this.$refs.messageData.toggleRowSelection(item, true);
        });
        this.selectDataList = this.messageData.map((item) => {
          return item.id;
        });
        this.selectAllFlag = true;
      } else {
        this.messageData.map((item) => {
          this.$refs.messageData.toggleRowSelection(item, false);
        });
        this.selectAllFlag = false;
        this.selectDataList = [];
      }
    },
    async deleteBtn() {
      if (!this.selectAllFlag) {
        const list = this.selectionList.map((item) => {
          return item.messageInfoVo.messageId;
        });
        await this.$confirm(`您确定要删除当前${list.length}项`, "警告", {
          type: "warning"
        });
        await request.messageDelete(list);
        this.addNewsNumKey();
      } else {
        const list = this.selectionList.map((item) => {
          return item.messageInfoVo.messageId;
        });
        await this.$confirm(`您确定要删除当前${list.length}项`, "警告", {
          type: "warning"
        });
        await request.messageDelete(list);
        this.addNewsNumKey();
      }
      await this.getList(1);
      this.$store.dispatch("unreadNum");
    },

    getSenderName(messageInfoVo) {
      if (messageInfoVo.senderId === "system") {
        return "系统";
      } else {
        return messageInfoVo.senderName || messageInfoVo.senderId || "系统";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.allNews {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 700px;
  // padding: 10px;
  box-sizing: border-box;
  .tabs {
    padding: var(--middle-space) var(--big-space) 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fff;
    border-bottom: 1px solid #ebefff;
    /deep/.el-badge__content {
      z-index: 1;
    }
    /deep/.el-radio-button__inner {
      padding: 10px 30px;
    }
    .role-auth-title {
      height: 35px;
      display: flex;
      li {
        line-height: 30px;
        margin-right: 30px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        font-weight: 600;
      }
      .active {
        border-bottom: 2px solid var(--theme-color);
        box-sizing: border-box;
        color: var(--theme-color);
      }
    }
    ::v-deep .right {
      .el-form-item__label{
        line-height: 32px;
      }
      .el-form-item__content{
        line-height: 32px;
      }
    }
  }
  .body {
    height: 1px;
    flex: 1 0 1px;
    overflow: hidden;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    .top {
      padding: var(--middle-space) var(--big-space);
      border-bottom: 1px solid #ebefff;
    }
    .table {
      flex: 1;
      padding: var(--middle-space) var(--big-space) 0;
      overflow: auto;
      .isReadBox{
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .isRead{
        width: 6px;
        height: 6px;
        border-radius: 6px;
        margin-right: 4px;
      }
      .isReadBg {
        background: #b5bed2;
      }
      .isNoReadBg {
        box-shadow: 0px 0px 4px rgba(56, 111, 254, 0.79);
        background: var(--theme-color);
      }
    }
    .page {
      padding: var(--middle-space) var(--big-space);
      .el-pagination {
        float: right;
      }
    }
  }
}
</style>
